// src/components/common/ProgramCard.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { SupportProgram } from '../../types';
import { getCategory } from '../../data/categories';
import Icon from './Icon';

interface ProgramCardProps {
    program: SupportProgram;
    /** 카테고리 배지 숨김 (카테고리 페이지 내부) */
    hideCategory?: boolean;
}

const ProgramCard: React.FC<ProgramCardProps> = ({ program, hideCategory }) => {
    const cat = getCategory(program.category);

    return (
        <article className="gh-card">
            <Link to={`/program/${program.slug}`} style={{ display: 'contents' }}>
                <div className="gh-card__top">
                    {!hideCategory && <span className="gh-card__cat">{cat.shortName}</span>}
                    {program.hot && <span className="gh-card__flag gh-card__flag--hot">인기</span>}
                    {program.isNew && <span className="gh-card__flag gh-card__flag--new">2026 변경</span>}
                </div>

                <h3 className="gh-card__title">{program.title}</h3>
                <p className="gh-card__summary">{program.summary}</p>

                <div className="gh-card__facts">
                    <div className="gh-fact">
                        <span className="gh-fact__k">지원금액</span>
                        <span className="gh-fact__v gh-fact__v--amount">{program.amount}</span>
                    </div>
                    <div className="gh-fact">
                        <span className="gh-fact__k">지원대상</span>
                        <span className="gh-fact__v">{program.eligibility}</span>
                    </div>
                    <div className="gh-fact">
                        <span className="gh-fact__k">신청시기</span>
                        <span className="gh-fact__v">{program.applicationPeriod}</span>
                    </div>
                </div>

                <div className="gh-card__foot">
                    <span className="gh-card__agency">{program.agency}</span>
                    <span className="gh-card__link">
                        자세히 보기
                        <Icon name="chevronRight" size={14} strokeWidth={2.2} />
                    </span>
                </div>
            </Link>
        </article>
    );
};

export default ProgramCard;
